import { render } from "./PageContent.vue?vue&type=template&id=5ab8e96e"
const script = {}

import "./PageContent.vue?vue&type=style&index=0&id=5ab8e96e&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__